export default "__VITE_ASSET__ae06778c__"